"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./PersonaPresence"), exports);
tslib_1.__exportStar(require("./PersonaPresence.base"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Persona/PersonaPresence/index.js
// module id = 1626
// module chunks = 0